/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: Dashboard
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], function() {
	return {
		6: 'dashboard/loader/upgrader/6',
		7: 'dashboard/loader/upgrader/7',
		8: 'dashboard/loader/upgrader/8',
		9: 'dashboard/loader/upgrader/9',
		1000: 'dashboard/loader/upgrader/wa_infographic',
		1002: 'dashboard/loader/upgrader/ca_updateSheet1InUploadedFile',
		1003: 'dashboard/loader/upgrader/waca_removeWidgetContentBoardSpec',
		1004: 'dashboard/loader/upgrader/waca',
		1005: 'dashboard/loader/upgrader/waca_shaping',
		1006: 'dashboard/loader/upgrader/VIDA_breakingchanges',
		1007: 'dashboard/loader/upgrader/multiLayersSupport',
		1008: 'dashboard/loader/upgrader/R9toR10',
		1009: 'dashboard/loader/upgrader/dateTimeLocalFilter',
		1010: 'dashboard/loader/upgrader/HeliosToEndorUpgrade',
		1011: 'dashboard/loader/upgrader/LayoutPageSizeUpgrade',
		1012: 'dashboard/loader/upgrader/LayoutPositioningUpgrade',
		1013: 'dashboard/loader/upgrader/VIDAPropUpgrade',
		1014: 'dashboard/loader/upgrader/DataItemIdUpgrade',
		1015: 'dashboard/loader/upgrader/DataItemUpgrade',
		1016: 'dashboard/loader/upgrader/CompositeChartUpgrade',
		1017: 'dashboard/loader/upgrader/FredIsRedUpgrade',
		1018: 'dashboard/loader/upgrader/DataItemAggregationTypeUpgrade',
		1019: 'dashboard/loader/upgrader/VIDA_ClippingUpgrade',
		1020: 'dashboard/loader/upgrader/VIDA_OptimizeSizeUpgrade',
		1021: 'dashboard/loader/upgrader/VIDA_LabelsColorPropUpgrade',
		1022: 'dashboard/loader/upgrader/TextWidgetResponsiveUpgradeHelper',
		1023: 'dashboard/loader/upgrader/LayoutTemplateIndicatorUpgrade',
		1024: 'dashboard/loader/upgrader/RecommendedDriversUpgrade',
		1025: 'dashboard/loader/upgrader/DataItemAggregationTypeUpgradeForScatterAndBubble',
		1026: 'dashboard/loader/upgrader/TextWidgetParagraphUpgrade',
		1027: 'dashboard/loader/upgrader/RankSlotUpgrade',
		1300: 'dashboard/loader/upgrader/VIDAPaddingPropUpgrade',
		1301: 'dashboard/loader/upgrader/DuplicateLayoutCssPropUpgrade',
		1400: 'dashboard/loader/upgrader/VIDALegendFontSizeMappingUpgrade',
		1401: 'dashboard/loader/upgrader/SummaryKPIUpgrade',
		1402: 'dashboard/loader/upgrader/WidgetTitleAriaLabelUpgrade',
		1403: 'dashboard/loader/upgrader/MissingOriginalCustomGroupItemId',
		1404: 'dashboard/loader/upgrader/DrillthroughDefinitionScopeUpgrade',
		1600: 'dashboard/loader/upgrader/TabIconUpgrade',
		1601: 'dashboard/loader/upgrader/CssAndFillColorConflictUpgrade',
		1800: 'dashboard/loader/upgrader/NewGenSpec',
		1801: 'dashboard/loader/upgrader/ColBarZeroOriginValueUpgrade',
		1802: 'dashboard/loader/upgrader/DatasetScopeMultiMeasure',
		1803: 'dashboard/loader/upgrader/CompositeChartV2Upgrade',
		1804: 'dashboard/loader/upgrader/CarbonPlexUpgrade',
		1805: 'dashboard/loader/upgrader/KPI_VCF_Upgrade',
		1806: 'dashboard/loader/upgrader/AggregateTypeVisibleUpgrade',
		1807: 'dashboard/loader/upgrader/CrosstabTable_VCF_Upgrade',
		1808: 'dashboard/loader/upgrader/FredIsRedColorMapUpgrade',
		2001: 'dashboard/loader/upgrader/ContrastLabelUpgrade',
		2002: 'dashboard/loader/upgrader/DrillthroughDefinitionEventGroupIdUpgrade',
		2003: 'dashboard/loader/upgrader/VIDARelativePaddingPropUpgrade',
		2004: 'dashboard/loader/upgrader/MoveOriginalCustomGroupItemId',
		2005: 'dashboard/loader/upgrader/VIDADefaultNullValuesUpgrade',
		2006: 'dashboard/loader/upgrader/ShowFooterUpgrade'

		// NOTE
		// When changing the spec version you must update the board version in
		// dashboard/loader/upgrader/all.js
	};
});
